// @owners { team: patients }
import { useQuery } from '@tanstack/react-query';
import { queries } from '~shared/queries/query-keys';
import { onboardingBackgroundColor } from '../helpers/onboardingBackgroundColor';

export const useQueryInsuranceConfigs = () => {
  const { isFetching, isError, isSuccess, data } = useQuery({
    ...queries.onboardingConfigs.fetchInsurance({ params: {} }),
  });

  const partnershipName = data?.data?.partnership_name;
  const headerBackgroundColor = onboardingBackgroundColor();

  return {
    headerBackgroundColor,
    headerLogoUrl: data?.data?.header_logo_url,
    isFetching,
    isError,
    isSuccess,
    partnershipName,
  };
};
